import React, { useEffect, useState } from 'react';

// material-ui
import { useTheme } from '@mui/material/styles';
import { Backdrop, Box, Chip as MuiChip, CircularProgress, Divider, Grid, Typography, OutlinedInput, InputAdornment, Pagination, TextField, Alert, IconButton, Tooltip, Autocomplete, Checkbox, Select, MenuItem } from '@mui/material';
import MainCard from 'src/components/cards/MainCard';
import Chip from 'src/components/Chip'


// assets
import ArcelikLogo from 'src/assets/images/arcelik_marka_logo.png';
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium';
import LinearProgress from '@mui/material/LinearProgress';
import axios from 'src/utils/axios';
import SearchIcon from '@mui/icons-material/Search';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import HighlightOffOutlinedIcon from '@mui/icons-material/HighlightOffOutlined';
import PrintIcon from '@mui/icons-material/Print';
import ExcelFileCreator from 'src/components/ExcelFileCreator';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import PlaylistAddCheckIcon from '@mui/icons-material/PlaylistAddCheck';




// ==============================|| PROFILE 1 -EDUCATION ||============================== //

const styles = {
  ul: {
    '& .MuiPaginationItem-root': {
      '&.Mui-selected': {
        background: '#FF9800',
        color: 'white',
        borderRadius: '50%',
      },
    },
  },
  backdrop: (theme) => ({
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff'
  }),
};

const Education = ({ EmployeeNr }) => {
  const theme = useTheme();


  if (EmployeeNr === 0) {
    return (
      <Grid container spacing={2}>
        <Grid
          size={{
            xs: 12,
            sm: 12,
            md: 12
          }}>
          <Alert variant="outlined" severity="error" sx={{ borderColor: theme.palette.warning.dark }}>
            <Typography variant='h5' style={{ color: 'red' }}>Önce Kayıt İşlemini Tamamlamanız Gerekli!....
            </Typography>
          </Alert>
        </Grid>
      </Grid>
    );
  }



  const [loading, setLoading] = useState(false);
  const [employeeEducationInfoData, setEmployeeEducationInfoData] = useState([]);
  const [search, setSearch] = useState("");
  const [selectedYear, setSelectedYear] = useState(0);
  const [filteredEmployeeEducationInfoData, setFilteredEmployeeEducationInfoData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 4; // Sayfa başına gösterilecek öğe sayısı
  const [displayedData, setDisplayedData] = useState([]);
  const years = Array.from({ length: 10 }, (_, index) => new Date().getFullYear() - index);
  const [employeeEducationCategories, setEmployeeEducationCategories] = useState([]);
  const [employeeEducationTypes, setEmployeeEducationTypes] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedType, setSelectedType] = useState([]);
  const SelectAllOption = { Id: "-1", Dsc: 'Tümünü Seç' };

  const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
  const checkedIcon = <CheckBoxIcon fontSize="small" style={{ color: '#FF9800' }} />;
  const selectAllIcon = <PlaylistAddCheckIcon fontSize="small" />;

  useEffect(() => {
    GetEmployeeEducationInfoData();
    GetEmployeeEducationCategories();
  }, []);


  const GetEmployeeEducationInfoData = () => {
    setLoading(true);
    var headers = {
      'Content-Type': 'application/json',
    };


    axios.get(`/GetEmployeeEducationInfo/${EmployeeNr}`, headers).then((response) => {
      if (response.data.length > 0) {
        setEmployeeEducationInfoData(response.data);
        setFilteredEmployeeEducationInfoData(response.data);
        setDisplayedData(response.data.slice(0, itemsPerPage));
      }
      else {
        setEmployeeEducationInfoData([]);
        setFilteredEmployeeEducationInfoData([]);
      }
      setLoading(false);
    });
  }

  const handleSearch = (event) => {
    setLoading(true);
    const searchText = event.target.value;
    setSearch(searchText);

    const filteredData = employeeEducationInfoData.filter((item) => {
      const courseNameIncludes = item.CourseName.toLowerCase().includes(searchText.toLowerCase());
      const lessonNameIncludes = item.LessonName.toLowerCase().includes(searchText.toLowerCase());
      return courseNameIncludes || lessonNameIncludes;
    });
    setCurrentPage(1);
    setFilteredEmployeeEducationInfoData(filteredData);
    setDisplayedData(filteredData.slice(0, itemsPerPage));
    setLoading(false);

  };

  const handleChangePage = (event, page) => {
    setCurrentPage(page);
    const begin = (page - 1) * itemsPerPage;
    const end = begin + itemsPerPage;

    const tempData = filteredEmployeeEducationInfoData.slice(begin, end);
    setDisplayedData(tempData);
  };


  const handleChangeYear = (event) => {
    setLoading(true);
    if (event.target.value === 0) {
      setSelectedYear(event.target.value);
      setCurrentPage(1);
      setFilteredEmployeeEducationInfoData(employeeEducationInfoData);
      setDisplayedData(employeeEducationInfoData.slice(0, itemsPerPage));
      setLoading(false);
      return;
    }
    else {
      setSelectedYear(event.target.value);
      const filteredData = employeeEducationInfoData.filter(item => {
        const dateParts = item.CourseAssignmentDate.split('.');
        const year = dateParts[2];
        return year == event.target.value;
      });
      setCurrentPage(1);
      setFilteredEmployeeEducationInfoData(filteredData);
      setDisplayedData(filteredData.slice(0, itemsPerPage));
      setLoading(false);
    }
  };

  const customPageStyle = {
    backgroundColor: '#f50057',

  };

  const handleExportClick = () => {
    var exportData = [];
    filteredEmployeeEducationInfoData.map((data) => {
      var exportItem = {
        "Eğitim Adı": data.CourseName,
        "Ders Adı": data.LessonName,
        "Eğitim Başlangıç Tarihi": data.CourseAssignmentDate,
        "Eğitim Bitiş Tarihi": data.CourseCompletionDate,
        "Eğitmen": data.TutorName,
        "Katılım Durumu": data.ParticipationStatus,
        "Tamamlanma Oranı": data.Percentage
      };
      exportData.push(exportItem);
    });

    ExcelFileCreator(exportData, `${EmployeeNr} - Eğitim Bilgileri`);
  };

  const GetEmployeeEducationCategories = () => {
    setLoading(true);
    axios.get(`/GetEmployeeEducationCategory`).then((response) => {
      if (response.data) {
        setEmployeeEducationCategories(response?.data?.CourseCategory);
        setEmployeeEducationTypes(response?.data?.CourseType);
        setLoading(false);
      }
      else {
        setEmployeeEducationCategories([]);
        setLoading(false);
      }
    });

  }

  const handleCategoryChange = (event, newValue) => {
    setSelectedCategory(newValue);
    if (newValue) {
      const filteredData = employeeEducationInfoData.filter(item => {
        return item.CourseCategory == newValue.Id;
      });
      setCurrentPage(1);
      setFilteredEmployeeEducationInfoData(filteredData);
      setDisplayedData(filteredData.slice(currentPage - 1, currentPage * itemsPerPage));
    }
    else {
      setCurrentPage(1);
      setFilteredEmployeeEducationInfoData(employeeEducationInfoData);
      setDisplayedData(employeeEducationInfoData.slice(currentPage - 1, currentPage * itemsPerPage));
    }
  };

  const handleTypeChange = (event, newValue) => {
    if (newValue.includes(SelectAllOption) ) {
      setSelectedType(employeeEducationTypes);
      setCurrentPage(1);
      setFilteredEmployeeEducationInfoData(employeeEducationInfoData);
      setDisplayedData(employeeEducationInfoData.slice(currentPage - 1, currentPage * itemsPerPage));
    }
    else if (newValue.length === 0) {
      setSelectedType([]);
      setCurrentPage(1);
      setFilteredEmployeeEducationInfoData(employeeEducationInfoData);
      setDisplayedData(employeeEducationInfoData.slice(currentPage - 1, currentPage * itemsPerPage));
    }
    else {
      const filteredData = employeeEducationInfoData.filter(item => {
        return newValue.map(i => i.Id).includes(item.CourseType);
      });
      setCurrentPage(1);
      setFilteredEmployeeEducationInfoData(filteredData);
      setDisplayedData(filteredData.slice(currentPage - 1, currentPage * itemsPerPage));
      setSelectedType(newValue);
    }

  };


  const getDataForCurrentPage = () => {
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    return filteredEmployeeEducationInfoData.slice(startIndex, endIndex);
  };

  const renderOption = (props, option, { selected }) => (
    option.Id == -1 ? (<li {...props}>
      <Checkbox
        icon={selectAllIcon}
        checkedIcon={selectAllIcon}
        style={{ marginRight: 8 }}
        checked={selected}
      />
      {option.Dsc}
    </li>) :
      (<li {...props}>
        <Checkbox
          icon={icon}
          checkedIcon={checkedIcon}
          style={{ marginRight: 8 }}
          checked={selected}
        />
        {option.Dsc}
      </li>)
  );

  return (
    <>
      <Typography variant="h5" sx={{ mb: 1 }}>Eğitimler</Typography>
      <Divider sx={{ mb: 2 }} />
      <Backdrop sx={styles.backdrop} open={loading}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <Box sx={{ mb: 2 }}
        >
          <Grid container justifyContent="space-between" alignItems="center" spacing={2}>
            <Grid
              size={{
                xs: 12,
                md: 12,
                xl: 3
              }}>
              <OutlinedInput
                id="input-search-card-style1"
                placeholder="Arama"
                fullWidth
                value={search}
                onChange={handleSearch}
                autoComplete="off"
                startAdornment={
                  <InputAdornment position="start">
                    <SearchIcon stroke={1.5} size="16px" />
                  </InputAdornment>
                }
              />
            </Grid>
            <Grid
              justifyContent="center"
              alignItems="center"
              size={{
                xs: 12,
                md: 12,
                xl: 5
              }}>
              <Grid container justifyContent="center" alignItems="center" >
                <Grid>
                  {filteredEmployeeEducationInfoData.length > 0 && <Pagination
                    count={Math.ceil(filteredEmployeeEducationInfoData.length / itemsPerPage)}
                    page={currentPage}
                    onChange={handleChangePage}
                    variant="outlined"
                    sx={styles.ul}
                  />}
                </Grid>
              </Grid>
            </Grid>
            <Grid
              size={{
                xs: 12,
                md: 12,
                xl: 4
              }}>
              <Grid container justifyContent="right" alignItems="center" spacing={2} >
                <Grid
                  size={{
                    xs: 12,
                    md: 12,
                    xl: 5
                  }}>
                  <Tooltip title="Yıl Seç">
                    <Select
                      onChange={handleChangeYear}
                      value={selectedYear}
                      defaultValue={0}
                      fullWidth
                      variant='outlined'
                      IconComponent={() => <CalendarMonthIcon style={{ color: '#546e7a' }} />}>
                      <MenuItem key={0} value={0}>Tümü</MenuItem>
                      {years.map((year) => (
                        <MenuItem key={year} value={year}>{year}</MenuItem>
                      ))}
                    </Select>
                  </Tooltip>
                </Grid>
                {/* <Grid item xs={12} md={12} xl={6}>
                  <Tooltip title="Kategori Seç">
                    <Autocomplete
                      disablePortal
                      value={selectedCategory}
                      onChange={(event, newValue) => {
                        handleCategoryChange(event, newValue);
                      }}
                      id="combo-box-demo"
                      options={employeeEducationCategories}
                      getOptionLabel={(option) => option.Dsc || ""}
                      renderInput={(params) => <TextField
                        {...params} label="Kategori Seç"
                      />}
                    />
                  </Tooltip>
                </Grid> */}
                <Grid
                  size={{
                    xs: 12,
                    md: 12,
                    xl: 6
                  }}>
                  <Autocomplete
                    multiple
                    options={employeeEducationTypes ? [SelectAllOption, ...employeeEducationTypes] : []}
                    value={selectedType}
                    getOptionLabel={(i) => i.Dsc}
                    renderOption={renderOption}
                    onChange={(event, val) => {
                      handleTypeChange(event, val);
                    }}
                    renderTags={(tagValue, getTagProps) => {
                      if (employeeEducationTypes.length > 0 && tagValue.length === employeeEducationTypes.length) {
                        return <MuiChip size="small" label={`Tümü (${tagValue.length})`} {...getTagProps({ index: 0 })} />;
                      }
                      const visibleCount = 1;
                      return (
                        <>
                          {tagValue.slice(0, visibleCount).map((option, index) => (
                            <MuiChip size="small" key={option.Id} label={option.Dsc} {...getTagProps({ index })} />
                          ))}
                          {tagValue.length > visibleCount && (
                            <MuiChip size="small" variant="outlined" label={`+${tagValue.length - visibleCount}`} />
                          )}
                        </>
                      );
                    }}
                    renderInput={(params) => <TextField {...params} label="Eğitim Tipi" variant="outlined" />}
                    fullWidth
                  />
                </Grid>
                <Grid
                  justifyContent="right"
                  alignItems="right"
                  size={{
                    xs: 12,
                    md: 12,
                    xl: 1
                  }}>
                  <Box display="flex" justifyContent="flex-end">
                    <Tooltip title="Yazdır">
                      <IconButton size="large" onClick={handleExportClick}>
                        <PrintIcon />
                      </IconButton>
                    </Tooltip>
                  </Box>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
      </Box>
      <Grid container spacing={3}>
        {search && filteredEmployeeEducationInfoData.length === 0 ?
          <Grid size={12}>
            <Alert variant="outlined" severity="warning" sx={{ borderColor: theme.palette.warning.dark }}>
              Aradığınız kriterlere uygun eğitim bulunamadı.
            </Alert>
          </Grid>
          : filteredEmployeeEducationInfoData.length === 0 ?
            <Grid size={12}>
              <Alert variant="outlined" severity="warning" sx={{ borderColor: theme.palette.warning.dark }}>
                Eğitim bilgisi bulunamadı.
              </Alert>
            </Grid> :
            getDataForCurrentPage().map((data) => (
              <Grid
                key={data.Id || data.CourseId || data.CourseType}
                size={{
                  xs: 12,
                  sm: 6,
                  md: 3
                }}>
                <MainCard
                  boxShadow
                  sx={{
                    pt: 1.75,
                    border: '2px solid',
                    borderColor: '#FF9800',
                    position: "relative",
                    height: '100%'
                  }}
                  contentSX={{
                    display: 'flex',
                    flexDirection: 'column',
                    height: '100%'
                  }}
                >

                  <WorkspacePremiumIcon
                    style={{
                      position: 'absolute',
                      top: 0,
                      right: 10,
                      fontSize: 40,
                      color: '#FF9800'
                    }} />

                  <Grid container textAlign="center" spacing={3}>
                    <Grid size={12}>
                      <Box sx={{ maxWidth: '100%', maxHeight: '100%' }}>
                        <img src={ArcelikLogo} alt='Arçelik Logo' style={{ width: '30%' }}></img>
                      </Box>
                    </Grid>
                    <Grid size={12}>
                      <Typography
                        variant="h6"
                        sx={{
                          fontSize: '1rem',
                          fontWeight: 500,
                          position: 'relative',
                          mb: 1,
                        }}
                      >
                        {data.CourseName}
                      </Typography>
                      <Typography
                        component="div"
                        variant="body2"
                        sx={{
                          fontSize: '0.9rem',
                          fontWeight: '700 !important',
                          '& > span': {
                            fontSize: '0.8rem',
                            fontWeight: '700 !important'
                          }
                        }}
                      >
                        {data.LessonName}
                      </Typography>

                    </Grid>
                    <Grid justifyContent="flex-start" alignItems="flex-start" size={12}>

                      <Typography
                        noWrap
                        component="div"
                        variant="body2"
                        sx={{
                          fontSize: '0.875rem',
                          fontWeight: 700,
                          textAlign: 'left',
                          '& > span': {
                            fontSize: '0.8rem',
                            fontWeight: 500
                          }
                        }}
                      >
                        <b>Eğitim Kategorisi:</b> {data.CourseCategory || "-"}
                      </Typography>
                      <Typography
                        component="div"
                        variant="body2"
                        sx={{
                          fontSize: '0.875rem',
                          fontWeight: 700,
                          textAlign: 'left',
                          '& > span': {
                            fontSize: '0.8rem',
                            fontWeight: 500
                          }
                        }}
                      >
                        <b>Eğitim Başlangıç:</b> {data.CourseAssignmentDate || "-"}
                      </Typography>
                      <Typography
                        component="div"
                        variant="body2"
                        sx={{
                          fontSize: '0.875rem',
                          fontWeight: 700,
                          textAlign: 'left',
                          '& > span': {
                            fontSize: '0.8rem',
                            fontWeight: 500
                          }
                        }}
                      >
                        <b>Eğitim Bitiş:</b> {data.CourseCompletionDate || "-"}
                      </Typography>
                      <Typography
                        component="div"
                        variant="body2"
                        sx={{
                          fontSize: '0.875rem',
                          fontWeight: 700,
                          textAlign: 'left',
                          '& > span': {
                            fontSize: '0.8rem',
                            fontWeight: 500
                          }
                        }}
                      >
                        <b>Eğitmen:</b> {data.TutorName}
                      </Typography>
                    </Grid>
                  </Grid>
                  <Box sx={{ mt: 'auto', pt: 2 }}>
                    <Grid container textAlign="center">
                      <Grid container justifyContent="center" alignItems="center" size={12} sx={{ mb: 1 }}>
                        {data.ParticipationStatus === "Tamamladı" || data.ParticipationStatus === "Katıldı" ?
                          <Chip
                            avatar={<CheckCircleOutlineIcon style={{ color: '#00c853' }} />}
                            label={data.ParticipationStatus}
                            chipcolor="success" />
                          :
                          <Chip
                            avatar={<HighlightOffOutlinedIcon style={{ color: '#f44336' }} />}
                            label={data.ParticipationStatus}
                            chipcolor="error" />

                        }
                      </Grid>
                      <Grid size={12}>
                        <Typography variant="caption">Tamamlanma Oranı</Typography>
                      </Grid>
                      <Grid size={12}>
                        <LinearProgress
                          variant="determinate"
                          color="success"
                          value={data.Percentage}
                        />
                      </Grid>
                      <Grid size={12}>
                        <Typography variant="h6">{data.Percentage}%</Typography>
                      </Grid>
                    </Grid>
                  </Box>
                </MainCard>
              </Grid>
            ))}
      </Grid>
    </>
  );
};

export default Education;
